<template>
  <div v-if="wrapshow" class="time-interval">
    <van-popup v-model="open" position="bottom" @closed="wrapshow = false">
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="close">取消</button>
        <div class="van-ellipsis van-picker__title">选择时间区间</div>
        <button type="button" class="van-picker__confirm" @click="confirm">确认</button>
      </div>
      <van-tabs v-model="active" animated>
        <van-tab  title="开始时间">
          <van-datetime-picker type="time" v-model="value1" :show-toolbar="false" :formatter="formatter"/>
        </van-tab>
        <van-tab  title="结束时间">
          <van-datetime-picker type="time" v-model="value2" :show-toolbar="false" :min-hour="value1.substr(0, 2)" :formatter="formatter"/>
        </van-tab>
      </van-tabs>
    </van-popup>
  </div>
</template>

<script>
function timeGetTime(str) {
  return Number(str.substr(0, 2) + str.substr(3, 2));
}

export default {
  data() {
    return {
      wrapshow: true,
      open: false,
      value1: "",
      value2: "",
      active: 0,
    };
  },
  methods: {
    formatter(type, val) {
      if (type === 'hour') {
        return `${val}时`;
      } else if (type === 'minute') {
        return `${val}分`;
      }
      return val;
    },
    showPicker(opts) {
      return new Promise((resolve) => {
        this.wrapshow = true;
        this.open = true;
        if (opts && opts.value1) {
          this.value1 = opts.value1;
          this.value2 = opts.value2;
        } else {
          this.value1 = "14:00";
          this.value2 = "15:00";
        }
        this._resolve = resolve;
      });
    },
    close(e) {
      this.open = false;
    },
    confirm() {
      if (this.active == 0) {
        this.active = 1;
      } else {
        if (timeGetTime(this.value1) < timeGetTime(this.value2)) {
          this.close();
          this._resolve({
            value1: this.value1,
            value2: this.value2,
          });
        } else {
          vant.Toast({
            message: '结束时间小于等于开始时间',
            position: 'bottom',
          });
        }
      }
    },
  },
  watch:{
    active (v) {
      if (v !==0 && timeGetTime(this.value1) >= timeGetTime(this.value2)) {
        this.value2 = this.value2.replace(/\d\d/, this.value1.slice(0,2))
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>

<style type="text/css">
  .time-interval .van-tabs__wrap {
    width: 150px;
    margin-left: 6px;
  }
</style>
